// ─── Config ───────────────────────────────────────────────────────────────────

import {AssetType} from "../../../components/AssetIcon/AssetType";

export const PAGE_LIMIT = 5;

export const CITY_OPTIONS = [
    {value: 'Pune', label: 'Pune'},
    {value: 'Mumbai', label: 'Mumbai'},
    {value: 'Bangalore', label: 'Bangalore'},
];

export const SEARCH_ASSET_CONFIG = {
    background: '#F5F5F5',
    border: '1px solid #E5E7EB',
};

export const CATEGORY_OPTIONS = [
    {value: undefined, label: 'All Assets (Default)', keys: []},
    {value: '1', label: 'Repos Fuel Datum', keys: [1]},
    {value: '8', label: 'Heavy Vehicle', keys: [8]},
    {value: '5', label: 'DG Set', keys: [5]},
    {value: '7', label: 'Infra. Machine', keys: [7]},
    {value: '6', label: 'Industrial', keys: [6]},
    {value: '12', label: 'Farming', keys: [12]},
    {value: '4', label: 'Others', keys: [4, 9]},
    {value: '13', label: 'Tank', keys: [13]},
];

export const SCREEN_CONFIG = {
    header: {
        title: 'Select Asset to Refuel',
        rightAction: {label: '+ Add'},
    },
    filterPanel: {
        title: 'Filter',
        cityLabel: 'City',
        cityNavigationIcon: '/static/images/ElockNodata.svg',
        cityChangeLabel: 'Change',
        categoryLabel: 'Asset Category',
        categories: CATEGORY_OPTIONS,
        onCityChange: () => {
            console.log("city call");
        },
    },
    search: {placeholder: 'Search for asset'},
    criticalLow: {
        title: 'Critical Low Fuel',
        itemConfig: {variant: 'chevron', showFuelLevel: true, background: '#ffffff', border: '1px solid #E5E7EB', fuelThresholds: {critical: 15, low: 30}},
    },
    allAssets: {
        title: 'All Assets',
        itemConfig: {variant: 'chevron', showFuelLevel: true, background: '#fff', border: '1px solid #E5E7EB', fuelThresholds: {critical: 15, low: 30}},
    },
};

export const normaliseAsset = (asset) => {
    const typeInfo = AssetType[asset?.asset_type];
    return {
        id: asset.id,
        title: asset.name,
        datum_model: asset.datum_model ?? null,
        fuelPercent: asset.available_percentage && asset.available_percentage !== 'N/A'
            ? parseFloat(asset.available_percentage)
            : 'N/A',
        icon: typeInfo?.imgpath ?? '/static/images/icons/iconsBarrier.svg',
        assetType: typeInfo
            ? `${typeInfo.Title}${typeInfo.Title1 ? ' ' + typeInfo.Title1 : ''}`
            : String(asset.asset_type ?? '—'),
        assetTypeNum: Number(asset.asset_type),

        // ── Finserv / pre-mapped partner fields ───────────────────────────────
        is_finserv_enabled: asset.is_finserv_enabled ?? false,
        // When is_finserv_enabled=true these come pre-filled on the asset itself
        partner_name: asset.partner_name ?? null,
        pump_logo: asset.pump_logo,
        pump_rate: asset.pump_rate ?? null,
        pump_id: asset.pump_id ?? null,
        last_is_pickup: asset.last_is_pickup ?? null,
        refueler_assigned: asset.refueler_assigned ?? null,
        last_payment_method: asset.last_payment_method ?? null,
        last_ordered_quantity: asset?.last_ordered_quantity ?? "2000",
        available_percentage: asset?.available_percentage ?? null,
        updated_at: asset?.updated_at ?? null,
        fleet_account_balance: asset?.fleet_account_balance ?? null,
        fleet_account_logo: asset?.fleet_account_logo ?? null,
        fleet_account_name: asset?.fleet_account_name ?? null,
        fleet_account_van: asset?.fleet_account_van ?? null,
        support_contact_number: asset?.support_contact_number ?? null,
        max_amount: asset?.max_amount ?? null,
        max_quantity: asset?.max_quantity ?? null,
        min_amount: asset?.min_amount ?? null,
        min_quantity: asset?.min_quantity ?? null,
    };
};